export default __webpack_public_path__ + "static/BannerJsonImageAndTextWithAction_ImageRightDark-a341682d3fd946a6c534e87cff6f0240.jpg";